// Minimal subscription manager for Super Subscriptions (Awtomic)
// Responsibilities: place widget in product form, sync selling_plan, update price

(function () {
	if (window.subscriptionManagerInitialized) return;
	window.subscriptionManagerInitialized = true;

	class SubscriptionManager {
		constructor() {
			this.debug = false;
			this._placementGuardTimer = null;
			this.init();
		}

		init() {
			if (document.readyState === 'loading') {
				document.addEventListener('DOMContentLoaded', () => this.onReady());
			} else {
				this.onReady();
			}
		}

		onReady() {
			this.ensureWidgetPlacement();
			this.syncSellingPlanFromSelection();
			this.startPlacementGuard();

			document.addEventListener('change', (e) => {
				if (!e.isTrusted) return;
				const t = e.target;
				if (!t || !t.matches) return;
				if (t.matches('input[type="hidden"]')) return;
				if (
					t.matches('input[type="radio"][name*="purchase_option"]') ||
					t.matches('input[type="radio"][name*="selling_plan"]') ||
					t.matches('select[name*="selling_plan"]')
				) {
					this.syncSellingPlanFromElement(t);
				}
			});
		}

		getProductContainer() {
			const candidates = [
				'div.product-form-wrapper',
				'product-information.product-form-wrapper',
				'product-information',
				'.product__info-wrapper',
				'.product',
				'.product-main',
				'[data-section-type*="product"]',
				'[id^="shopify-section-product"]',
			];
			for (const sel of candidates) {
				const el = document.querySelector(sel);
				if (el) return el;
			}
			const form = document.querySelector('form[action*="/cart/add"]');
			if (form) {
				return (
					form.closest(
						'[data-section-type*="product"], section, .product, .product-main, .product__info-wrapper'
					) || form.parentElement
				);
			}
			return document.body;
		}

		startPlacementGuard() {
			if (this._placementGuardTimer) return;
			let attempts = 0;
			this._placementGuardTimer = setInterval(() => {
				attempts++;
				try {
					this.ensureWidgetPlacement();
					this.syncSellingPlanFromSelection();
				} catch {}
				const formHasPlan = !!document
					.querySelector('form[action*="/cart/add"]')
					?.querySelector(
						'input[name="selling_plan"], select[name*="selling_plan"]'
					);
				if (attempts >= 12 || formHasPlan) {
					clearInterval(this._placementGuardTimer);
					this._placementGuardTimer = null;
				}
			}, 500);
		}

		ensureWidgetPlacement() {
			const productContainer = this.getProductContainer();
			const productForm = document.querySelector('form[action*="/cart/add"]');
			if (!productContainer) return;

			const target = productForm || productContainer;

			const findWidgetRoot = (el) => {
				if (!el) return null;
				let node = el;
				while (node && node !== document.body) {
					if (
						node.classList &&
						(node.classList.contains('super-subscriptions-widget') ||
							node.classList.contains('ss-widget') ||
							node.classList.contains('awtomic-widget') ||
							node.classList.contains('super-simple-subs-wrapper') ||
							node.hasAttribute('data-super-subscriptions') ||
							node.hasAttribute('data-ss-widget') ||
							node.hasAttribute('data-awtomic') ||
							node.id === 'super-simple-subs-wrapper-embed')
					) {
						const appBlock = node.closest('.shopify-block.shopify-app-block');
						return appBlock || node;
					}
					node = node.parentElement;
				}
				return el;
			};

			const candidates = [
				'#super-simple-subs-wrapper-embed',
				'.super-simple-subs-wrapper',
				'.purchase-options-wrapper',
				'fieldset.fetcher-selling-plan-fieldset',
				'[data-super-subscriptions]',
				'[data-ss-widget]',
				'[data-awtomic]',
			];

			const seen = new Set();
			candidates.forEach((sel) => {
				document.querySelectorAll(sel).forEach((n) => {
					if (productContainer.contains(n)) return;
					if (n.closest('#CartDrawer, .drawer, [role="dialog"]')) return;
					const root = findWidgetRoot(n);
					if (!root || seen.has(root)) return;
					seen.add(root);
					try {
						target.appendChild(root);
						root.style.pointerEvents = '';
						root.style.position = 'static';
						root.style.left =
							root.style.right =
							root.style.top =
							root.style.bottom =
								'';
						root.style.zIndex = '';
						root.style.maxWidth = '100%';
						root.classList.add('subscription-widget--moved');
						root
							.querySelectorAll(
								'input[disabled],select[disabled],button[disabled]'
							)
							.forEach((el) => el.removeAttribute('disabled'));
					} catch (e) {
						if (this.debug) console.warn('Move widget failed', e);
					}
				});
			});

			if (productForm) {
				const hasPlan = !!productForm.querySelector(
					'input[name="selling_plan"], select[name*="selling_plan"]'
				);
				if (!hasPlan) {
					const external = (productContainer || document).querySelector(
						'input[name="selling_plan"], select[name*="selling_plan"]'
					);
					if (external)
						try {
							productForm.appendChild(external);
						} catch {}
				}

				const group = (productContainer || document).querySelector(
					'.purchase-options-wrapper, fieldset.fetcher-selling-plan-fieldset, fieldset[product-variant-id], .selling-plan-group, [data-selling-plan-group]'
				);
				if (group) {
					const checked = group.querySelector(
						'input[type="radio"][name*="selling_plan"]:checked, input[type="radio"][name*="purchase_option"]:checked'
					);
					const first = group.querySelector(
						'input[type="radio"][name*="selling_plan"], input[type="radio"][name*="purchase_option"]'
					);
					if (!checked && first) {
						first.checked = true;
						this.syncSellingPlanFromElement(first);
					}

					group.querySelectorAll('input[type="radio"]').forEach((r, idx) => {
						const pid = r.getAttribute('sss-selling-plan-id') || r.value || '';
						if (!r.id) r.id = pid || `ss-option-${Date.now()}-${idx}`;
						let label =
							group.querySelector(`label[for="${r.id}"]`) ||
							(pid ? group.querySelector(`label[for="${pid}"]`) : null);
						if (label && label.getAttribute('for') !== r.id)
							label.setAttribute('for', r.id);
						if (!label) {
							const wrapped = r.closest('label');
							if (wrapped && !wrapped.getAttribute('for'))
								wrapped.setAttribute('for', r.id);
						}
					});
				}
			}
		}

		ensureSellingPlanInput(planId = null) {
			const productForm = document.querySelector('form[action*="/cart/add"]');
			if (!productForm) return null;
			let input = productForm.querySelector('input[name="selling_plan"]');
			if (!input) {
				input = document.createElement('input');
				input.type = 'hidden';
				input.name = 'selling_plan';
				productForm.appendChild(input);
			}
			if (planId) {
				input.value = String(planId);
				input.dispatchEvent(new Event('change', { bubbles: false }));
				this.updateWidgetHiddenSellingPlan(String(planId));
			}
			return input;
		}

		updateWidgetHiddenSellingPlan(planId) {
			try {
				const productContainer = this.getProductContainer() || document;
				productContainer
					.querySelectorAll(
						'#super-simple-subs-wrapper-embed input[type="hidden"][name="selling_plan"], .super-simple-subs-wrapper input[type="hidden"][name="selling_plan"], .purchase-options-wrapper input[type="hidden"][name="selling_plan"], fieldset.fetcher-selling-plan-fieldset input[type="hidden"][name="selling_plan"]'
					)
					.forEach((el) => {
						if (el.value !== planId) {
							el.value = planId;
							el.dispatchEvent(new Event('change', { bubbles: false }));
						}
					});
			} catch {}
		}

		getSelectedPlanId() {
			const productContainer = this.getProductContainer() || document;
			const checked = productContainer.querySelector(
				'input[type="radio"][name*="purchase_option"]:checked, input[type="radio"][name*="selling_plan"]:checked'
			);
			return checked
				? checked.getAttribute('sss-selling-plan-id') ||
						checked.value ||
						checked.id ||
						null
				: null;
		}

		syncSellingPlanFromElement(element) {
			if (!element) return;
			const name = element.getAttribute('name') || '';
			if (!/purchase_option|selling_plan/.test(name)) return;
			const planId =
				element.getAttribute('sss-selling-plan-id') || element.value || null;
			if (!planId) return;
			this.ensureSellingPlanInput(planId);
			this.updatePriceForSellingPlan(planId);
		}

		syncSellingPlanFromSelection() {
			const planId = this.getSelectedPlanId();
			if (planId) {
				this.ensureSellingPlanInput(planId);
				this.updatePriceForSellingPlan(planId);
			}
		}

		updatePriceForSellingPlan(planId) {
			try {
				const productContainer = this.getProductContainer() || document;
				let variantId = null;
				const form = document.querySelector('form[action*="/cart/add"]');
				const idInput = form?.querySelector(
					'input[name="id"], select[name="id"]'
				);
				if (idInput) variantId = idInput.value;
				else if (window.sssubscriptionsProduct?.variants?.[0]?.id)
					variantId = String(window.sssubscriptionsProduct.variants[0].id);
				if (!variantId || !window.sssPriceLabels) return;
				const label =
					window.sssPriceLabels[String(variantId)]?.[String(planId)];
				if (!label?.price) return;
				const priceText =
					label.price.withCurrency || label.price.withoutCurrency;
				if (!priceText) return;
				const priceSelectors = [
					'[data-product-price] [data-price-text].money',
					'[data-product-price] .money',
					'[data-product-price]',
					'.product-price-group .money',
					'.price .money',
					'.product__price .price-item--regular',
					'.product__price .price-item',
					'.product-price__price',
				];
				for (const sel of priceSelectors) {
					const el = productContainer.querySelector(sel);
					if (el) {
						if (el.hasAttribute && el.hasAttribute('data-product-price')) {
							const money = el.querySelector('.money') || el;
							money.textContent = priceText;
						} else {
							el.textContent = priceText;
						}
						break;
					}
				}
			} catch (e) {
				if (this.debug) console.warn('Price update failed', e);
			}
		}
	}

	window.SubscriptionManager = SubscriptionManager;
	new SubscriptionManager();
})();
